import { useCallback, useReducer } from 'react';
import { createRecordDraft, hasRecordChanges, recordDraftReducer } from '../utils/personRecordDraft';

export default function usePersonRecordDraft(initialValue) {
  const [state, dispatch] = useReducer(recordDraftReducer, initialValue,
    (value) => createRecordDraft(typeof value === 'function' ? value() : value));
  const receive = useCallback((value) => dispatch({ type: 'receive', value }), []);
  const reset = useCallback((value) => dispatch({ type: 'reset', value }), []);
  const edit = useCallback((value) => dispatch({ type: 'edit', value }), []);
  const saved = useCallback((sent, result, generation) => {
    const record = result?.student || result?.attendee || result;
    dispatch({ type: 'saved', sent, saved: record?.id ? record : sent, generation });
  }, []);
  return { value: state.value, receive, reset, edit, saved, dirty: hasRecordChanges(state), generation: state.generation };
}
